@if (items?.length) {
  <div
    class="insta-learn-topics-widget"
    [style.color]="textColor">
    @if (swiperComponent()?.canSlide() || title) {
      <div
        class="insta-learn-topics-widget__header animate__animated"
        [class.has-title]="title"
        [ngClass]="animation"
        [style.animationDelay.ms]="animationDelay">
        <h4 class="widget-title">{{ title }}</h4>
        @if (swiperComponent()?.canSlide()) {
          <div class="widget-navigation">
            <button
              mat-icon-button
              class="button button--icon button--icon-extra-small"
              [disabled]="swiperComponent()?.swiper?.isBeginning"
              (click)="swiperComponent()?.swiper?.slidePrev()">
              <lib-icon icon="arrow-left"></lib-icon>
            </button>
            <button
              mat-icon-button
              class="button button--icon button--icon-extra-small"
              [disabled]="swiperComponent()?.swiper?.isEnd"
              (click)="swiperComponent()?.swiper?.slideNext()">
              <lib-icon icon="arrow-right"></lib-icon>
            </button>
          </div>
        }
      </div>
    }
    <div class="insta-learn-topics-widget__carousel">
      <lib-swiper class="widget-slider" [slides]="items" [options]="swiperOptions()">
        <ng-template swiperContent let-slide="item" let-index="index">
          <div
            class="insta-topic animate__animated"
            [ngClass]="animation"
            [style.animationDelay.ms]="animationDelay * (index + 1)"
            [class.inactive]="!slide?.unreadCount"
            (click)="openTopic.emit(slide)">
            <div class="topic-media-container">
              <div class="posts-counter">{{ slide?.unreadCount }}</div>
              <img
                class="topic-image"
                [cropImage]="slide?.mediaImage | preSignedUrl | async"
                [crop]="slide?.mediaImage?.crop"
                [additionalOptions]="slide?.mediaImage?.additionalMediaProps"
                [imageWidth]="400">
            </div>
            <h5 class="topic-title">{{slide.title}}</h5>
          </div>
        </ng-template>
      </lib-swiper>
    </div>
  </div>
}
